<template>
  <el-table-column
    prop="type"
    sortable="custom"
    label="Típus"
    show-overflow-tooltip
    min-width="100"
    show-tooltip-when-overflow
  >
    <template slot-scope="scope">
      <span v-if="scope.row.type === 'stowage'">
        Rakodási lista
      </span>
    </template>
  </el-table-column>
</template>

<script>
export default {
  propName: 'type',
};
</script>
